<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication"><a id="page_v"></a><em>For my readers<br/>Who sent me emails and messages that made me smile<br/>Who told their friends about my books<br/>Who stayed with this series from start to finish<br/>Who knew me long before that,<br/>and who have encouraged me all these years<br/>I wrote this last one for all of you</em>.<br/><em>—Elizabeth May</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03dedication.vue?26bff877